import React, { Fragment, useContext } from 'react';
import AddFleetDialog from './AddFleetDialog';
import AddFleetOptionDialog from './AddFleetOptionDialog';
import { store } from '../Fleets';

const Dialogs = () => {
  const { state, dispatch } = useContext(store);
  const { addFleetDialog, addFleetOptionsDialog } = state;
  return (
    <Fragment>
      {addFleetDialog ? <AddFleetDialog f={addFleetDialog} /> : null}
      {addFleetOptionsDialog ? (
        <AddFleetOptionDialog f={addFleetOptionsDialog} />
      ) : null}
    </Fragment>
  );
};

export default Dialogs;
